import { Feature } from '@lib/graphql/__generated__/graphql'
import { isToDo } from '@utils/Task'

export const getReminderType = (reminderRow: any) => {
  if (reminderRow) {
    switch (true) {
      case isToDo(reminderRow.task):
        return REMINDER_TYPE.toDo
      case !!reminderRow.goal:
        return REMINDER_TYPE.goal
      case !!reminderRow.milestone:
        return REMINDER_TYPE.milestone
      case !!reminderRow.task:
        return REMINDER_TYPE.task
      case !!reminderRow.productionPlanningProject:
        return REMINDER_TYPE.productionPlanning
      case !!reminderRow.keyMilestonesProject:
        return REMINDER_TYPE.keyActivity
      case !!reminderRow.keyActivity:
        return REMINDER_TYPE.keyActivity
      case !!reminderRow.comment:
        return REMINDER_TYPE.comment
      case !!reminderRow.thread:
        return REMINDER_TYPE.thread
      default:
        return null
    }
  }
}

export const getReminderTypeLabel = (
  reminderType: REMINDER_TYPE | string,
  t: any,
): string => {
  switch (reminderType) {
    case REMINDER_TYPE.toDo:
      return t('dashboard.reminderType.todo')
    case REMINDER_TYPE.goal:
      return t('dashboard.reminderType.goal')
    case REMINDER_TYPE.milestone:
      return t('dashboard.reminderType.activity')
    case REMINDER_TYPE.task:
      return t('dashboard.reminderType.task')
    case REMINDER_TYPE.productionPlanning:
      return t('dashboard.reminderType.productionPlanning')
    case REMINDER_TYPE.thread:
      return t('dashboard.reminderType.thread')
    case REMINDER_TYPE.keyActivity:
      return t('dashboard.reminderType.keyActivity')
    case REMINDER_TYPE.comment:
      return t('dashboard.reminderType.comment')
    case 'todosAssigned':
      return t('dashboard.reminderType.todosAssignedToMe')
    case 'todosCreatedByMe':
      return t('dashboard.reminderType.todosCreatedByMe')
    case 'todosFollowedByMe':
      return t('dashboard.reminderType.todosFollowedByMe')
    case 'assignedTask':
      return t('dashboard.reminderType.tasksAssignedToMe')
    case 'tasksCreatedByMe':
      return t('dashboard.reminderType.tasksCreatedByMe')
    case 'tasksFollowedByMe':
      return t('dashboard.reminderType.tasksFollowedByMe')
    default:
      return ''
  }
}

export enum REMINDER_TYPE {
  goal = 'goal',
  milestone = 'milestone',
  task = 'task',
  productionPlanning = 'productionPlanning',
  keyActivity = 'keyActivity',
  comment = 'comment',
  toDo = 'toDo',
  thread = 'thread',
}

export const REMINDER_TYPE_FEATURES = {
  [REMINDER_TYPE.productionPlanning]: Feature.AdvancedProductionPlanning,
} as const
